import { Injectable } from '@angular/core';
import { RoutingService } from '@rci/routing-service';
import { UserInformationStateFacade } from '@rci/self-serve-fido/state/user-information/user-information-state.facade';

@Injectable()
export class NavigationService {
  constructor(
    private readonly userInformationStateFacade: UserInformationStateFacade,
    private readonly routingService: RoutingService,
  ) {}

  setAccountNumberAndNavigate(accountNumber: string, url: string, phoneNumber = '', skipAccountSelectorModal = false) {
    this.userInformationStateFacade.updateSelectedAccountNumber(accountNumber);
    if (phoneNumber) {
      this.userInformationStateFacade.updateSelectedSubscriberNo(phoneNumber);
    }
    setTimeout(() => this.routingService.navigate(url, null, { skipAccountSelectorModal }));
  }
}
